export function createAnswer(userAnswers: any[][]) {
  const bpAnswersFirst = 'studio_BPAnswer';
  const answersStr = userAnswers
    .map((answersList) => {
      return answersList
        .map((answer) => {
          return answer;
        })
        .join('-');
    })
    .join('_');
  return bpAnswersFirst.concat('_' + answersStr);
}
